export function getConfig() {
  const legacyPrefix = ['PAW', 'BOND'].join('');
  const legacyIdPrefix = legacyPrefix.toLowerCase();
  const legacyConfig = window[`${legacyPrefix}_CONFIG`] as PortraitConfig | undefined;
  const mount =
    document.getElementById('portrait-upload-app') ||
    document.getElementById('portrait-preview-app') ||
    document.getElementById(`${legacyIdPrefix}-upload-app`) ||
    document.getElementById(`${legacyIdPrefix}-preview-app`);
  const sectionConfig = readSectionConfig(mount);
  const globalConfig = window.PORTRAIT_CONFIG || legacyConfig;
  const comparisonImages = sanitizeComparisonImages(sectionConfig.comparisonImages || globalConfig?.comparisonImages);

  return {
    apiBaseUrl: mount?.dataset.apiBaseUrl || globalConfig?.apiBaseUrl || 'http://localhost:3000',
    instantVariantId: mount?.dataset.instantVariantId || globalConfig?.instantVariantId || '',
    refinedVariantId: mount?.dataset.refinedVariantId || globalConfig?.refinedVariantId || '',
    shopCurrency: globalConfig?.shopCurrency || 'USD',
    packages: sectionConfig.packages || globalConfig?.packages,
    comparisonImages,
    reviews: sectionConfig.reviews || globalConfig?.reviews,
    trademark: sectionConfig.trademark || globalConfig?.trademark || 'Pawfect Portrait Print'
  };
}

function sanitizeComparisonImages(images?: string[]) {
  const cleaned = images?.filter((image) => image && !isLegacySampleAsset(image)) || [];
  return cleaned.length ? cleaned : undefined;
}

function isLegacySampleAsset(url: string) {
  return url.includes('cdn.shopify.com/s/files/1/0986/5628/9070/files/mix-');
}

function readSectionConfig(mount: HTMLElement | null) {
  if (!mount) return {};
  const legacyPrefix = ['paw', 'bond'].join('');
  const script = mount.parentElement?.querySelector<HTMLScriptElement>(
    `script[data-portrait-section-config], script[data-${legacyPrefix}-section-config]`
  );
  if (!script?.textContent) return {};

  try {
    return JSON.parse(script.textContent) as Pick<PortraitConfig, 'packages' | 'comparisonImages' | 'reviews' | 'trademark'>;
  } catch {
    return {};
  }
}
